module.exports = [{"type":"title","text":"2024-12-06"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USDT-M: Query all pending orders API /openApi/swap/v2/trade/openOrders Support query based on order type"},{"type":"html","text":"Perpetual USDT-M: Cancel all pending orders API /openApi/swap/v2/trade/allOpenOrders Support cancellation based on order type"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-12-06.json
// module id = 2XCm
// module chunks = 3